import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', href: '/' },
    { label: '剧情片', href: '/category/drama' },
    { label: '纪录片', href: '/category/documentary' },
    { label: '原创短片', href: '/category/shortfilm' },
    { label: '喜剧', href: '/category/comedy' },
    { label: '科技', href: '/category/tech' },
  ],
  关于我们: [
    { label: '品牌故事', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '创作者入驻', href: '/about#creator' },
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '版权声明', href: '/about' },
  ],
  内容类型: [
    { label: '文化类视频', href: '/category/culture' },
    { label: '动画作品', href: '/category/animation' },
    { label: '纪录片佳作', href: '/category/documentary' },
    { label: '科技前沿', href: '/category/tech' },
    { label: '创意短片', href: '/category/shortfilm' },
    { label: '喜剧作品', href: '/category/comedy' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2.5 mb-4 no-underline">
                <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-background-50 text-base">
                  国产视频精选
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                发现优质国内原创内容，感受中国影视创作的蓬勃活力与创意魅力。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 国产视频精选平台 版权所有 | 京ICP备2026000001号
            </p>
            <p className="text-xs text-background-500">
              用心发现每一部好作品 · 让创作更有价值
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}